import { FormattedMessage } from 'react-intl';
import { Logout, MessageQuestion, NotificationBing, Wifi } from 'iconsax-react';

const icons = {
  help: MessageQuestion,
  notification: NotificationBing,
  logout: Logout,
  wifi: Wifi
};

const help = {
  id: 'group-help',
  // title: <FormattedMessage id="help" />,
  type: 'group',
  icon: icons.help,
  children: [
    {
      id: 'livecall',
      title: <FormattedMessage id="livecall" />,
      type: 'item',
      url: '/livecall',
      icon: icons.wifi
    },
    {
      id: 'help',
      title: <FormattedMessage id="help" />,
      type: 'item',
      url: '/help',
      icon: icons.help
    },
    {
      id: 'notification',
      title: <FormattedMessage id="notification" />,
      type: 'item',
      url: '/notifications',
      icon: icons.notification
    },
    {
      id: 'logout',
      title: <FormattedMessage id="logout" />,
      type: 'item',
      // url: '/logout',
      icon: icons.logout
    }
  ]
};

export default help;
